import { FC } from 'react';
import { Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';

interface Props {
    name: string;
    label: string;
    placeholder: string;
    control?: any;
    mask?: string;
    error?: { message: string };
}

const Input: FC<Props & any> = ({ name, label, placeholder, control, error, ...props }) => {
    return (
        <div>
            {label && <p className="mb-1 font-bold text-md">{label}</p>}
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <InputMask
                        placeholder={placeholder}
                        className="p-3 w-full font-medium bg-gray-50 rounded-md placeholder:font-normal"
                        maskChar={null}
                        {...props}
                        {...field}
                    />
                )}
            />
            {error && <p className="text-sm text-red-600">{error?.message}</p>}
        </div>
    );
};

export default Input;
